<template>
  <el-table-column
    prop="comment"
    sortable="custom"
    label="Megjegyzés"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.comment }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'comment',
  };
</script>
